import { render, staticRenderFns } from "./uservisitrecords.vue?vue&type=template&id=5993eb03&"
import script from "./uservisitrecords.vue?vue&type=script&lang=js&"
export * from "./uservisitrecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports